import React from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { Box } from '@mui/material';
import { isDateElement } from 'utils/typeGuards';

export default function Date({ currentElement }: DraggableComponentProps) {
  if (!isDateElement(currentElement)) {
    return null;
  }
  const { labelText } = currentElement.content;
  return (
    <Box alignItems={'center'} display={'flex'} height={'50px'} justifyContent={'center'} margin={'0 4px'}>
      <span>{labelText}</span>
    </Box>
  );
}
